import { __extends } from "tslib";
import React from 'react';
import { assign } from 'lodash-es';
export default function disableiOSScroll(Component) {
    var DisablediOSScroll = /** @class */ (function (_super) {
        __extends(DisablediOSScroll, _super);
        function DisablediOSScroll() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.onTouchMove = function (e) {
                e.preventDefault();
            };
            return _this;
        }
        DisablediOSScroll.prototype.render = function () {
            var elementsTree = _super.prototype.render.call(this);
            if (!elementsTree) {
                return null;
            }
            var newProps = {
                onTouchMove: this.onTouchMove,
            };
            var props = assign({}, elementsTree.props, newProps);
            var newElementsTree = React.cloneElement(elementsTree, props, elementsTree.props.children);
            return newElementsTree;
        };
        return DisablediOSScroll;
    }(Component));
    return DisablediOSScroll;
}
